




































import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import user from '@/store/modules/user';
import CompanyMixin from '@/mixins/CompanyMixin';
import { CompanyDocument } from '../store/models';
import * as api from '@/store/api';

@Component
export default class MetaValuation extends CompanyMixin {
    @Prop() readonly doc!: CompanyDocument;

    overviewM: any = {};

    @Watch('doc', { immediate: true, deep: true })
    async onDocChanged() {
        // tslint:disable-next-line:max-line-length
        this.overviewM = await api.getOverview(this.doc.Data.AggVersion, this.doc.Data.OrgNr);
    }

    get overview() {
        return this.overviewM;
    }
}
